import React from "react";
import * as actions from './actions';
export default function FilterCategory({ eleRef , eleThis}) {
    const items = [];

    const sublistul = [];

    for (const [index, value] of eleRef.entries()) {
        var sublist = [];

        items.push(
             <li key={index} className={`${value.filterTitle.toLowerCase()} active`} id={value.filterTitle.toLowerCase()} onClick={() => actions.showSubCat(`${(value.filterTitle.toLowerCase())}`)}>
                <span className="catname R14_42">{value.filterTitle.charAt(0).toUpperCase() + value.filterTitle.slice(1)}</span>
                <div className="subcatCount"></div>
            </li>);

        sublistul.push(<ul key={`a_${index}`} className={`sub${value.filterTitle.toLowerCase()} subcategorieslist active`}>
            {sublist}
        </ul>);
        for(const [index, result] of value.values.entries()){
            sublist.push(<li key={`b_${index}`} onClick={(e) => actions.checkfiltersubcat(e)} >
                <span className="icon check left" data-icon-font="z"></span>
                <span className="subcatname R14_42">{result.key}</span>
            </li>);
        }
    }

    return (
        <div className="filter-overlay overlay">
            <div className="filter-popup filter_popups">
                <div className="filter_by">
                    <span className="M18_42">Filter By</span>
                    <span className="right icon" data-icon-font="C" onClick={(e) => actions.cancelpopup(e)}></span>
                </div>
                <div className="catg_filter">
                    <ul className="left">
                        <li className="category_list">
                            <ul className="left categorieslist">
                               {items}
                            </ul>
                        </li>
                        <li className="subcategory_list">
                            <div className="filter_search left">
                                <span className="icon searchflticon" data-icon-font="'"></span>
                                <input className="R14_42" type="text" id="sabcat_search" onKeyUp={() => actions.mysearchlist()} placeholder="Search" autoFocus/>
                            </div>
                           {sublistul}
                        </li>
                    </ul>
                </div>
                <div className="cancel_apply_btn">
                    <div className="submit_btns">
                        <div className="cancelfilter M14_9e" onClick={(e) => actions.clearAll(e)}>
                            CLEAR ALL
                        </div>
                        <div className="applyfilter M14_pink dev_listfilter" onClick={(e) => actions.applyfilter(e, eleThis)}>
                            APPLY
                        </div>
                    </div>
                    <input type="hidden" id="cubcatstrr" value=" " />
                </div>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// src/shared/baby-names/FilterCategory.js